import React from "react"

const Payment = () => {
  return (
    <div className="billing checkout-form__form">
      <div className="checkout-form-count">3</div>
      <h1 className="title-md">Payment</h1>
      <div className="input-box">
        <label htmlFor="cardNumber">Card Number:</label>
        <input
          type="number"
          name="cardNumber"
          id="cardNumber"
          // value={formData?.city}
          // required
          // onChange={(e) =>
          //   setFormData((prev) => ({
          //     ...prev,
          //     [e.target.name]: e.target.value,
          //   }))
          // }
        />
      </div>
      <div className="input-box">
        <label htmlFor="cardName">Name on Card</label>
        <input
          readOnly
          type="text"
          name="cardName"
          id="cardName"
          // value={formData?.country}
        />
      </div>
      <div className="input-flex-box">
        <div className="input-box f-grow">
          <label htmlFor="expDate">Expire Date</label>
          <input
            type="date"
            name="expDate"
            id="expDate"
            required
            // value={formData?.state}
            // onChange={(e) =>
            //   setFormData((prev) => ({
            //     ...prev,
            //     [e.target.name]: e.target.value,
            //   }))
            // }
          />
        </div>
        <div className="input-box">
          <label htmlFor="secCode">Security code</label>
          <input
            className="number-input"
            type="number"
            name="secCode"
            id="secCode"
          />
        </div>
      </div>
      <div className="input-box">
        <label htmlFor="promo">Promo Code?</label>
        <input type="text" name="promo" id="promo" />
      </div>
    </div>
  )
}

export default Payment
